import { useEffect, useMemo, useState } from "react";
import styles from "./filters.module.scss";
import DatePicker from "./DatePicker/DatePicker";
import DealershipPicker from "./DealershipPicker/DealershipPicker";
import { FiltersDashboardProps } from "../../../../interfaces/components";
import { formatDate } from "../../../../helpers/app";
import { useToast } from "../../../../helpers/hooks";

type FilterOptions = {value: string; label: string;} | null;

const Filters = ({
    user,
    setBranchDashboard,
    setDateDashboard,
    branches,
    getBranches,
    cleanBranches
}: FiltersDashboardProps) => {
    const toast = useToast();
    const [selectedOption, setSelectedOption] = useState<FilterOptions>(null);

    const onChangeDatePicker = (value: any) => {
        setDateDashboard(formatDate(value?.from, true), formatDate(value?.to, true));
    }

    const options: any = useMemo(() => {
        let data: any = (user?.profile?.code === "admin-dealership") 
        ? [{
            value: "all",
            label: "Todas las sucursales"
        }] 
        : [];
        data = data.concat(branches.data && branches.data.map((branch: any) => (
            {
                value: branch?._id,
                label: branch?.name
            }
        )));
        return data;
    }, [branches.data]);

    useEffect(() => {
        if(user?.profile?.code === "admin-dealership" && options && options.length > 0){
            setSelectedOption(options[0]);
        }
    }, [options]);
    
    useEffect(() => {
        if(user?.profile?.code === "admin-dealership" && selectedOption){
            setBranchDashboard(selectedOption?.value);
        }
        if(user?.profile?.code !== "admin-dealership"){
            setBranchDashboard(selectedOption ? selectedOption?.value : "");
        }
    }, [selectedOption]);

    useEffect(() => {
        if(branches.fetching === "failure"){
            toast("Ha ocurrido un error al buscar las sucursales");
            cleanBranches();
        }
        if(branches.fetching === "success"){
            cleanBranches();
        }
    }, [branches?.fetching]);
    
    useEffect(() => {
        if(user && user?.profile?.code !== "admin-brand"){
            getBranches(user?.dealership, "branches");
        }
    }, []);

    return(
        <>
            {
                user?.profile?.code === "admin-dealership" &&
                <div className={styles.branchFilter}>
                    <DealershipPicker
                        placeholder="Sucursales"
                        value={selectedOption}
                        onChange={(value) => setSelectedOption(value)}
                        options={options}
                        className={styles.selectDealership}
                    />
                </div>
            }
            <div className={styles.datePickerFilter}>
                <DatePicker onChange={onChangeDatePicker} />
            </div>
        </>
    )
};

export default Filters;